import { Guid, isNil, Nillable } from '@web/utils';

export class AdminOrderShipmentFormItem {
  public constructor(
    private readonly data: {
      id?: Nillable<Guid>;
      name: string;
      quantity: number;
      featuredFileAlt?: Nillable<string>;
      featuredFileUrl?: Nillable<string>;
      sourceName?: Nillable<string>;
    },
  ) {}

  public get id(): Nillable<Guid> {
    return this.data.id;
  }

  public get name(): string {
    return this.data.name;
  }

  public get quantity(): number {
    return this.data.quantity;
  }

  public get featuredFileAlt(): Nillable<string> {
    return this.data.featuredFileAlt;
  }

  public get featuredFileUrl(): Nillable<string> {
    return this.data.featuredFileUrl;
  }

  public get sourceName(): Nillable<string> {
    return this.data.sourceName;
  }

  public get isResolved(): boolean {
    return !isNil(this.data.id);
  }

  public withQuantity(quantity: number): AdminOrderShipmentFormItem {
    return new AdminOrderShipmentFormItem({
      ...this.data,
      quantity,
    });
  }
}
